export const REASON_TOTAL_CODE = 'total';
